<template>
    <div>
        <div
            class="w-full mx-auto text-gray-800 overflow-hidden bg-blue-200 dark:bg-gray-900 rounded-md shadow sm:max-w-lg ring-1 ring-gray-600 cursor-pointer mb-4 space-y-2">
            <p v-if="loading" class="p-3 dark:text-gray-400">Carregando informações da página...</p>
            <div v-else-if="!previewData" class="p-3  dark:text-gray-400">
                <p>Falha ao carregar informações da página.</p>
                <a v-if="props.isPreview" :href="props.url" class="w-full text-semibold">
                    {{ props.url }}
                </a>
            </div>
            <div v-else class="flex flex-col text-gray-700 dark:text-gray-300" @click="handleClick">
                <a v-if="!props.isPreview" :href="previewData.url" class="w-full" target="_blank">
                    <img v-if="previewData.image" :src="previewData.image" alt=""
                         class="object-cover w-full" style="height: 10em;"/>
                </a>

                <div class="flex  flex-col p-3 space-y-1">
                    <a :href="previewData.url"
                       class="m-0 text-lg text-gray-700 dark:text-gray-400 leading-tight text-gray-900 no-underline hover:no-underline hover:text-gray-900 sm:text-xl"
                       target="_blank">
                        {{ previewData.title }}
                    </a>
                    <p class="text-gray-600 dark:text-gray-400">
                        {{ previewData.url }}
                    </p>
                    <p class="text-sm">
                        {{ previewData.description }}
                    </p>
                </div>
            </div>
        </div>
        <div class="p-3  text-gray-600 dark:text-gray-300" v-html="whatsAppParser(props.caption)"></div>
    </div>
</template>

<script lang="ts" setup>
import {onMounted, ref} from "vue";
import MessageService from "@src/services/message"
import {whatsAppParser} from "@src/helpers/messageHelper"

const props = defineProps(['url', 'isPreview', 'caption'])

const loading = ref(false);
const previewData = ref<any>(null);

onMounted(() => {
    loading.value = true
    fetchData(props.url)
});

const fetchData = async (url: string) => {
    loading.value = true
    previewData.value = await MessageService.getLinkData(url)
    loading.value = false
};

const handleClick = () => {
    window.open(props.url, '_blank', 'noopener,noreferrer');
}
</script>

<style scoped>

</style>